var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C11.8326 17 11.6756 16.9714 11.5291 16.9141C11.3827 16.8569 11.2466 16.7595 11.1211 16.6221L5.34529 10.3015C5.1151 10.0496 5 9.72901 5 9.33969C5 8.95038 5.1151 8.62977 5.34529 8.37786C5.57549 8.12595 5.86846 8 6.22422 8C6.57997 8 6.87294 8.12595 7.10314 8.37786L12 13.7366L16.8969 8.37786C17.1271 8.12595 17.42 8 17.7758 8C18.1315 8 18.4245 8.12595 18.6547 8.37786C18.8849 8.62977 19 8.95038 19 9.33969C19 9.72901 18.8849 10.0496 18.6547 10.3015L12.8789 16.6221C12.7534 16.7595 12.6173 16.8569 12.4709 16.9141C12.3244 16.9714 12.1674 17 12 17Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBlack);
export default __webpack_public_path__ + "static/media/chevron_down_black.d0f33e89ff722439c34d0d2a6b4b2998.svg";
export { ForwardRef as ReactComponent };